import styled from '@emotion/styled'

export const StyleRow = styled.div`
  display: flex;
  justify-content: space-between;
`
export const StyleSelectedCardWrapper = styled.div`
  width: 60%;
  border-radius: 12px;
  background: ${(props: any) => props.theme.colors.white};
  padding: 15px;
`

export const StyleSearchWrapper = styled.div`
  width: 38%;
  border-radius: 12px;
  background: ${(props: any) => props.theme.colors.white};
  padding: 15px;
`
